"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarksClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class BookmarksClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.version = 'v1';
    }
    addGoalBookmark(projectId, goalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(this.getPath(projectId, `goals/${goalId}/bookmarked`), {});
            return response.payload;
        });
    }
    removeGoalBookmark(projectId, goalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(this.getPath(projectId, `goals/${goalId}/bookmarked`));
            return response.payload;
        });
    }
    addSegmentBookMark(projectId, segmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(this.getPath(projectId, `segments/${segmentId}/bookmarked`), {});
            return response.payload;
        });
    }
    removeSegmentBookmark(projectId, segmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(this.getPath(projectId, `segments/${segmentId}/bookmarked`));
            return response.payload;
        });
    }
    getPath(projectId, path = '') {
        return `/${this.version}/projects/${projectId}/${path}`;
    }
}
exports.BookmarksClient = BookmarksClient;
//# sourceMappingURL=bookmarks.client.js.map